import { makeBuilder } from '../../../utils/makeBuilder.ts';
import { TranslationArraySchema } from './types/TranslationArraySchema.ts';
import { TranslationKeyedObjectSchema } from './types/TranslationKeyedObjectSchema.ts';
import { TranslationObjectSchema } from './types/TranslationObjectSchema.ts';
import { TranslationRteSchema } from './types/TranslationRteSchema.ts';
import { TranslationStringSchema } from './types/TranslationStringSchema.ts';
import { TranslationWidgetSchema } from './types/TranslationWidgetSchema.ts';

export type ITranslationSchema =
  | TranslationWidgetSchema
  | TranslationObjectSchema
  | TranslationKeyedObjectSchema
  | TranslationArraySchema
  | TranslationStringSchema;

// Shortcut per la costruzione degli schemi
const widget = makeBuilder(TranslationWidgetSchema);
const object = makeBuilder(TranslationObjectSchema);
const keyedObject = makeBuilder(TranslationKeyedObjectSchema);
const array = makeBuilder(TranslationArraySchema);
const string = makeBuilder(TranslationStringSchema);

const rteSchema = new TranslationRteSchema(
  object({
    text: string().omitKey(),
  }),
);

const singleRteSchema = object({
  text: string().omitKey(),
});

/** Schema di traduzione per le regole di validazione */
const rulesSchema = keyedObject(
  object({
    customMessage: string(),
    minCustomMessage: string(),
    maxCustomMessage: string(),
  }),
);

export const tran = {
  widget,
  object,
  keyedObject,
  array,
  string,
  rte: () => rteSchema,
  singleRte: () => singleRteSchema,
  rules: () => rulesSchema,
};
